__webpack_require__.p = "/services/insurer/assets/_next/";